"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeOfContentCollectionPropertyOption = exports.isTypeOfContentCollectionProperty = exports.typeOfContentCollectionPropertyDefinition = void 0;
const typeOfContentCollectionPropertyOptions = [
    'discipline',
    'custom',
    'playlist',
];
exports.typeOfContentCollectionPropertyDefinition = {
    view: { label: 'Type of Content Collection' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'options',
            argument: typeOfContentCollectionPropertyOptions,
        },
    ],
    type: 'select',
    multiple: false,
    name: 'type-of-content-collection',
};
const isTypeOfContentCollectionProperty = (prop) => {
    return prop.name === exports.typeOfContentCollectionPropertyDefinition.name;
};
exports.isTypeOfContentCollectionProperty = isTypeOfContentCollectionProperty;
const isTypeOfContentCollectionPropertyOption = (option) => {
    return typeOfContentCollectionPropertyOptions.includes(option);
};
exports.isTypeOfContentCollectionPropertyOption = isTypeOfContentCollectionPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS1vZi1jb250ZW50LWNvbGxlY3Rpb24ucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90eXBlLW9mLWNvbnRlbnQtY29sbGVjdGlvbi5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLHNDQUFzQyxHQUFHO0lBQzdDLFlBQVk7SUFDWixRQUFRO0lBQ1IsVUFBVTtDQUNGLENBQUE7QUFFRyxRQUFBLHlDQUF5QyxHQUFHO0lBQ3ZELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSw0QkFBNEIsRUFBRTtJQUM3QyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLHNDQUFzQztTQUNqRDtLQUNGO0lBQ0QsSUFBSSxFQUFFLFFBQVE7SUFDZCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSw0QkFBNEI7Q0FDSCxDQUFBO0FBSTFCLE1BQU0saUNBQWlDLEdBQUcsQ0FBQyxJQUFrQixFQUEyQyxFQUFFO0lBQy9HLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxpREFBeUMsQ0FBQyxJQUFJLENBQUE7QUFDckUsQ0FBQyxDQUFBO0FBRlksUUFBQSxpQ0FBaUMscUNBRTdDO0FBSU0sTUFBTSx1Q0FBdUMsR0FBRyxDQUFDLE1BQWMsRUFBbUQsRUFBRTtJQUN6SCxPQUFRLHNDQUE0RCxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQTtBQUN2RixDQUFDLENBQUE7QUFGWSxRQUFBLHVDQUF1QywyQ0FFbkQifQ==